"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferModalBody = OfferModalBody;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const BussinesObjectSelectors_1 = require("../../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const GenericComponents_1 = require("../../../View/Modals/CommonFormComponents/GenericComponents");
const InlineCreateDrawers_1 = require("../../../View/Modals/InlineCreateDrawers");
const EntitiesController_1 = require("../../../Entities/EntitiesController");
const OtherAttributesSelectors_1 = require("../../../View/Modals/CommonFormComponents/OtherAttributesSelectors");
const StatusSelectors_1 = require("../../../View/Modals/CommonFormComponents/StatusSelectors");
const FormContext_1 = require("../../../View/Modals/FormContext");
function OfferModalBody({ isEditing, initialData }) {
    const { register, reset, setValue, watch, formState: { dirtyFields, errors, isValid }, trigger, } = (0, FormContext_1.useFormContext)();
    const _city = watch("_city");
    const [showCreateEmployer, setShowCreateEmployer] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const resetData = {
            _city: initialData?._city,
            _type: initialData?._type,
            _employer: initialData?.employerName,
            alias: initialData?.alias || "",
            description: initialData?.description || "",
            comment: initialData?.comment || "",
            creationDate: initialData?.creationDate || new Date().toISOString().slice(0, 10),
            submissionDeadline: initialData?.submissionDeadline,
            status: initialData?.status || "",
            bidProcedure: initialData?.bidProcedure || "",
            form: initialData?.form || "",
        };
        reset(resetData);
        trigger();
    }, [initialData, reset]);
    function renderCityText() {
        if (typeof _city !== "string")
            return "";
        return "System utworzy nowe miasto w bazie i wygeneruje dla niego trzyliterowy kod. Upewnij się, że podałano nazwę bez literówek i, że system nie podpowiada Ci już tego miasta";
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !isEditing && (react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "_city" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Miasto"),
                react_1.default.createElement(BussinesObjectSelectors_1.CitySelector, { showValidationInfo: true, allowNew: true }),
                react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, renderCityText())),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "_type" },
                react_1.default.createElement(BussinesObjectSelectors_1.ContractTypeSelector, { typesToInclude: "our" })))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, null,
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Zamawiaj\u0105cy"),
            react_1.default.createElement(BussinesObjectSelectors_1.EntitySelector, { name: "_employer", multiple: false, onRequestCreate: () => setShowCreateEmployer(true) })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "alias" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Alias"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "text", placeholder: "Podaj alias", isValid: !errors?.alias, isInvalid: !!errors?.alias, ...register("alias") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: "alias" })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "description" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Opis"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 3, placeholder: "Podaj opis", isValid: !errors?.description, isInvalid: !!errors?.description, ...register("description") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "description", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "comment" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Uwagi"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 3, placeholder: "Dodaj uwagi", isValid: !errors?.comment, isInvalid: !!errors?.comment, ...register("comment") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "comment", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "creationDate" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Data utworzenia"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", isValid: !errors.creationDate, isInvalid: !!errors.creationDate, ...register("creationDate") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "creationDate", errors: errors })),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "submissionDeadline" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Termin sk\u0142adania"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", isValid: !errors.submissionDeadline, isInvalid: !!errors.submissionDeadline, ...register("submissionDeadline") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "submissionDeadline", errors: errors }))),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(OtherAttributesSelectors_1.OfferBidProcedureSelectFormElement, { as: react_bootstrap_1.Col }),
            react_1.default.createElement(OtherAttributesSelectors_1.OfferFormSelectFormElement, { as: react_bootstrap_1.Col })),
        react_1.default.createElement(StatusSelectors_1.OfferStatusSelector, { multiple: false }),
        react_1.default.createElement(InlineCreateDrawers_1.EntityInlineCreateDrawer, { show: showCreateEmployer, onHide: () => setShowCreateEmployer(false), title: "Nowy podmiot (zamawiaj\u0105cy)", repository: EntitiesController_1.entitiesRepository, onCreated: (created) => setValue("_employer", created, { shouldValidate: true }) })));
}
